import React from 'react';
import clsx from 'clsx';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { reFetchConfig } from '@/hooks/paging';
import selectors from '../hooks/selectors';
import fetch from '../hooks/fetch';

const ThemesPanelContainer = ({
  category,
  className,
  children,
  compact,
}) => {
  const state = selectors.useThemesPanelContainer({ category });
  const config = compact ? reFetchConfig(state.themes, state) : undefined;
  fetch.useFetchThemes({ category }, state.readStatus, config);

  return (
    <PanelContainer canAccess={state.canEdit} readErrors={state.readErrors} exists>
      <div className={clsx('aridhia-themes-panel-container', className)}>
        { children }
      </div>
    </PanelContainer>
  );
};

export default ThemesPanelContainer;
